export default __webpack_public_path__ + "static/media/activate.8e8eb7e4.svg";